var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70703 6.29303C6.5195 6.4805 6.26519 6.58582 6.00003 6.58582C5.73486 6.58582 5.48056 6.4805 5.29303 6.29303L0.707028 1.70703C0.567219 1.56718 0.472013 1.38901 0.433445 1.19506C0.394877 1.00111 0.41468 0.800074 0.490351 0.617374C0.566021 0.434675 0.69416 0.278512 0.85857 0.168627C1.02298 0.058743 1.21628 7.15256e-05 1.41403 2.90871e-05L10.586 2.90871e-05C10.7838 7.15256e-05 10.9771 0.058743 11.1415 0.168627C11.3059 0.278512 11.434 0.434675 11.5097 0.617374C11.5854 0.800074 11.6052 1.00111 11.5666 1.19506C11.528 1.38901 11.4328 1.56718 11.293 1.70703L6.70703 6.29303Z",
    fill: "#848484"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bb2011c22054e884067e23ff4b77bff9.svg";
export { ForwardRef as ReactComponent };